import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Inputfiledsbase } from '../../../models/inputfiledsbase';
import { DropdownQuestion } from '../../../question-dropdown';
import { TextboxQuestion } from '../../../question-textbox';
import { ApiservicesService } from '../../../../Services/Apis/apiservices.service';
import { DropdownservicesService } from '../../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { MultiSelectQuestion } from '../../../question-multiselect';

@Injectable({
  providedIn: 'root',
})
export class SectionsService {
  organisationdata: any = [];
  semisterdata: any = [];
  sectiondata: any = [];
  regsectiondata: any = [];
  academicyeardropdata: any = [];
  coursewisesemisterdata: any = [];
  selectedcourse_id: number | undefined;
  selectedacadmicyear_id: number | undefined;
  private dataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private courselistSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  courselist$: Observable<any[]> = this.courselistSubject.asObservable();
  assignsectiondata: any = [];
  selectedacademic_regulation_id: any;
  // sectiondatafromcomponent: Observable<any[]> | undefined;
  private sectiondatafromcomponent: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  sectiondatafromcomponent$: Observable<any[]> = this.sectiondatafromcomponent.asObservable();
  private componentMethodCaller = new Subject<any>();
  componentMethodCalled$ = this.componentMethodCaller.asObservable();
  studentsectiondata: any = [];
  sectionformat: any[] = [];

  constructor(private apiservice: ApiservicesService, private dropdownservice: DropdownservicesService) {
// this.loadDropdownData('SEMISTER', this.semisterdata);
//     this.loadDropdownData('SECTIONS', this.sectiondata);

//     this.apiservice.getcourseslist().subscribe((res) => {
//       const courselist = res.rows.map((course: any) => ({
//         'course_ID': course.id,
//         'name': course.course_name
//       }));
//       this.courselistSubject.next(courselist);
//     });

    // this.apiservice.getsemisterdetails().subscribe((res) => {
    //   const semisterlist = res.semister_number;
    // });
  }

   loadDropdownData(code: string, dataArray: any[]) {
    let observable: Observable<any>;
    if (code === 'SEMISTER') {
      observable = this.dropdownservice.getsemisterdrop();
    } else if (code === 'COURSEWISESEMISTER') {
      observable = this.dropdownservice.getcoursewisesemesterdrop({course_id :this.selectedcourse_id, academic_regulation_id: this.selectedacademic_regulation_id,academic_calendar_id : this.selectedacadmicyear_id});
    } else if (code === 'ACADEMICYEAR') {
      observable = this.dropdownservice.getcoursewiseacademicyeardrop({ course_id: this.selectedcourse_id, academic_regulation_id: this.selectedacademic_regulation_id });
    } else if (code === 'REGSECTIONS') {
      observable = this.sectiondatafromcomponent;
    } else if (code === 'STUDENTSECTIONS') {
      observable = this.dropdownservice.gettablesectionsdrop({ course_ID: this.selectedcourse_id, academic_regulation_id: this.selectedacademic_regulation_id });
    }else{
      observable = this.dropdownservice.getlookupcodesdropdown(code);
    }

    observable.subscribe((res) => {

      for (let i = 0; i < res.length; i++) {
        let lookupname;
        if (code === 'COURSEWISESEMISTER') {
          lookupname = res[i]?.semister;
        } else if (code === 'SEMISTER' || 'SECTIONS' || 'REGSECTIONS' || 'STUDENTSECTIONS') {
          lookupname = res[i]?.name;
        } else {
          lookupname = res[i]?.lookup_name;
        }
        dataArray.push({
          id: res[i].id,
          key: lookupname,
          value: res[i].id,
        });
      }
    });
  }

  setData(data: any) {
    this.dataSubject.next(data);
  }

  getData(): Observable<any> {
    return this.dataSubject.asObservable();
  }

  onsemisterChange(selectedValue: any): void {
    // for (let i = 0; i < selectedValue?.length; i++) {
    //   if (selectedValue[i].id !== '' && selectedValue[i].name !== '') {
    //     this.sectiondata?.push({ id: selectedValue[i]?.id, key: selectedValue[i]?.name, value: selectedValue[i]?.id })
    //   }
    // }
    this.sectiondata.splice(0, this.sectiondata.length);
    this.loadDropdownData('STUDENTSECTIONS', this.sectiondata);
  }

  onacadmicyearChange(selectedValue: any): void {
    this.selectedacadmicyear_id = selectedValue;
    this.coursewisesemisterdata.splice(0, this.coursewisesemisterdata.length);
    this.loadDropdownData('COURSEWISESEMISTER', this.coursewisesemisterdata);
  }

  filtersections(selectedValue: any): void {
    for (let i = 0; i < selectedValue?.length; i++) {
      if (selectedValue[i].id !== '' && selectedValue[i].name !== '') {
        this.assignsectiondata?.push({ id: selectedValue[i]?.id, key: selectedValue[i]?.name, value: selectedValue[i]?.name })
      }
    }
  }

  filtersectionsdata(selectedValue: any): void {
    for (let i = 0; i < selectedValue?.length; i++) {
      if (selectedValue[i].id !== '' && selectedValue[i].name !== '') {
        this.regsectiondata?.push({ id: selectedValue[i]?.id, key: selectedValue[i]?.name, disable: selectedValue[i].is_selected, value: selectedValue[i]?.name })
      }
    }
  }

  studentpromotesectionchange(data: any) {
    this.componentMethodCaller.next(data);
  }

  getRegulationstudentfilterForm(event: any): Observable<Inputfiledsbase<string>[]> {
    // academic_year_id
    this.selectedcourse_id = event?.course_id;
    this.selectedacademic_regulation_id = event?.academic_regulation_id;
    // this.loadDropdownData('COURSEWISESEMISTER', this.coursewisesemisterdata);
    this.loadDropdownData('ACADEMICYEAR', this.academicyeardropdata);
    // this.loadDropdownData('SECTIONS', this.sectiondata);
    this.apiservice.getcourseslist().subscribe((res) => {
      const courselist = res.rows.map((course: any) => ({
        'course_ID': course.id,
        'name': course.course_name
      }));
      this.courselistSubject.next(courselist);
    });
    // this.onsemisterChange(event?.sections);
    return new Observable((observer) => {

      const createquestions: Inputfiledsbase<string>[] = [
        new DropdownQuestion({
          key: 'academic_year_id',
          label: 'Academic Year',
          required: true,
          options: this.academicyeardropdata,
          onChange: this.onacadmicyearChange.bind(this),
          order: 1,
        }),
        new DropdownQuestion({
          key: 'semister_id',
          label: 'Semister',
          required: true,
          options: this.coursewisesemisterdata,
          onChange: this.onsemisterChange.bind(this),
          order: 2,
        }),
        new DropdownQuestion({
          key: 'section_id',
          label: 'Section',
          required: false,
          options: this.sectiondata,
          order: 3,
        }),
      ];
      observer.next(createquestions.sort((a, b) => a.order - b.order));
      observer.complete();
    })
  }

  getstudentpromotefilterForm(event: any): Observable<Inputfiledsbase<string>[]> {
    // academic_year_id
    this.selectedcourse_id = event?.course_id;
    this.selectedacademic_regulation_id = event?.academic_regulation_id;
    this.loadDropdownData('STUDENTSECTIONS', this.studentsectiondata);

    return new Observable((observer) => {

      const createquestions: Inputfiledsbase<string>[] = [
        new DropdownQuestion({
          key: 'section_id',
          label: 'Section',
          required: true,
          options: this.studentsectiondata,
          onChange: this.studentpromotesectionchange.bind(this),
          order: 1,
        }),
      ];
      observer.next(createquestions.sort((a, b) => a.order - b.order));
      observer.complete();
    })
  }

  getCreateSectionForm(): Observable<Inputfiledsbase<string>[]> {

  this.dropdownservice.getsectionstype().subscribe((res: any[]) => {
    res.forEach((item, index) => {
      const obj = {
        id: index,
        key: item,
        value: item
      };
      this.sectionformat.push(obj);
    });
  });

    return new Observable((observer) => {
      const createquestions: Inputfiledsbase<string>[] = [

        new TextboxQuestion({
          key: 'count',
          label: 'Count',
          type: 'number',
          required: true,
          // patterns: '^\\d{1,2}(\\.\\d{1,2})?$',
          order: 1,
        }),

        new DropdownQuestion({
          key: 'format',
          label: 'Section Format',
          required: true,
          options: this.sectionformat,
          order: 2
        })

        // new TextboxQuestion({
        //   key: 'name',
        //   label: 'Section Name',
        //   required: true,
        //   order: 3,
        // }),
      ];
      observer.next(createquestions.sort((a, b) => a.order - b.order));
      observer.complete();
    });
  }

  getCreatebatchSectionForm(Sectiondata: any): Observable<Inputfiledsbase<string>[]> {
    // this.loadDropdownData('REGSECTIONS', this.regsectiondata);
    // this.sectiondatafromcomponent = Sectiondata;
    // this.sectiondatafromcomponent.next(Sectiondata)
    this.regsectiondata = []
    this.filtersectionsdata(Sectiondata);
    return new Observable((observer) => {
      const createquestions: Inputfiledsbase<string>[] = [

        new MultiSelectQuestion({
          key: 'section_id',
          label: 'Section',
          required: true,
          options: this.regsectiondata,
          order: 1,
        })

      ];
      observer.next(createquestions.sort((a, b) => a.order - b.order));
      observer.complete();
    });
  }

  getassigntoSectionForm(event: any): Observable<Inputfiledsbase<string>[]> {
    this.assignsectiondata = [];
    this.filtersections(event?.sections);
    return new Observable((observer) => {
      const createquestions: Inputfiledsbase<string>[] = [

        new DropdownQuestion({
          key: 'section_name',
          label: 'Section',
          required: true,
          options: this.assignsectiondata,
          order: 1,
        })

      ];
      observer.next(createquestions.sort((a, b) => a.order - b.order));
      observer.complete();
    });
  }
}
